import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useNavigate as useNavigateBase } from 'react-router-dom';
import { useSearchParams } from 'src/utils/useSearchParams';
import mixCustomizationParam from './mixCustomizationParam';
import type { ToType } from './mixCustomizationParam';

// необходимо, чтобы при любом переходе сохранялся параметр customization, т.к. с его помощью определяется
// внешний вид некоторых страниц для банков партнеров и для пользователя нежелательно при каком-либо переходе
// в агенте внезапно получить дефолтное отображение сайта
export const useNavigate = (params: { browserNavigation: boolean } | void) => {
  const { browserNavigation } = params || {};
  const navigate = useNavigateBase();
  const [searchParams] = useSearchParams();
  const customization = searchParams.get('customization');

  const browserNavigate = useCallback(
    (to: ToType | number) => {
      if (typeof to === 'number') {
        // для браузерной навигации запрещен navigate как в реакт роутере с помощью чисел
        return;
      }

      const mixedTo = mixCustomizationParam(to, customization);

      const url = new URL(
        typeof mixedTo === 'string' ? mixedTo : mixedTo.pathname || '',
        window.location.origin
      );
      if (typeof mixedTo !== 'string') {
        if (mixedTo.search) {
          url.search = mixedTo.search.startsWith('?') ? mixedTo.search : `?${mixedTo.search}`;
        }
        if (mixedTo.hash) {
          url.hash = mixedTo.hash.startsWith('#') ? mixedTo.hash : `#${mixedTo.hash}`;
        }
      }

      window.location.assign(url.href);
    },
    [customization]
  );

  const routerNavigate = useCallback(
    (to: ToType | number, ...rest: any) => {
      if (typeof to === 'number') {
        navigate(to);
      } else {
        const mixedTo = mixCustomizationParam(to, customization);
        navigate(mixedTo, ...rest);
      }
    },
    [navigate, customization]
  );

  return browserNavigation ? browserNavigate : routerNavigate;
};
